import styled from 'styled-components'
import logo from '../../../../assets/licito-logo.svg'
import menuLateralIcon from '../../../../assets/menuLateralIcon.svg'
import History from './history/history'
import {useContext, useState, useRef, useEffect, useMemo} from 'react'
import HideShowBarButton from '../../../../globalComponents/hideShowBarButton'
import Button from '../../../../globalComponents/ButtonPattern'
import {AuthContext} from '../../../../contexts/auth'
import NavList from './navList'
import {HistoryContext} from '../../../../contexts/history'
import {Button as MuiButton, List, Tooltip} from '@mui/material'
import {useLocation, useNavigate} from 'react-router-dom'
import MessageIcon from '../../../../assets/message-text.svg'
import FolderIcon from '../../../../assets/folder-open.svg'
import exitIcon from '../../../../assets/exit.svg'
import AddCommentOutlinedIcon from '@mui/icons-material/AddCommentOutlined'
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined'
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined'
import FindInPageOutlinedIcon from '@mui/icons-material/FindInPageOutlined'
import PersonSearchOutlinedIcon from '@mui/icons-material/PersonSearchOutlined'
import {getCurrentColors} from '../../../../utils/colors'
import {getCurrentImages} from '../../../../utils/logos'

import {useJwt} from 'react-jwt'
import {CookiesService} from '../../../../services/Cookie.service'

const COLORS = getCurrentColors()
const IMAGES = getCurrentImages()
const LEFTBAR_WIDTH = '248px'

const Section = styled.section<{show: boolean}>`
    width: ${({show}) => (show ? LEFTBAR_WIDTH : '0px')};
    min-width: ${({show}) => (show ? LEFTBAR_WIDTH : '0px')};
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px 0px 28px 0;
    justify-content: space-between;
    position: relative;
    transform: translateX(${({show}) => (show ? '0' : '-100%')});
    transition: transform 0.3s ease-in-out;
    z-index: 55;
    border-right: 1px solid #e0e0e0;
    @media (max-width: 640px) {
        position: absolute;
        min-height: 100vh;
    }
    overflow-y: auto;
    background-color: #ffffff;
`

const Logo = styled.img`
    width: 168px;
    height: 64px;
    margin-left: 10px;
`
const SeconderyLogo = styled.img`
    width: 115px;
    height: 10px;
    margin-left: 15px;
`

const ListWrapper = styled.div`
    width: 100%;
    display: flex;
    position: relative;
    align-items: flex-start;
`

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 20px;
`

const ButtonsContainer = styled.div`
    flex-direction: column;
    width: 100%;
    gap: 8px;
    align-items: flex-start;
`
const CreditsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: 214px;
    height: 58px;
    gap: 6px;
    margin-top: 14px;
    margin-left: 14px;
    margin-bottom: 14px;
    border: 1px solid #e4e4e4;
    border-radius: 8px;
`
const CreditsContainerTop = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    margin-left: 12px;
    width: 100%;
`
const CreditsContainerBottom = styled.div<{pathname: string}>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 220px;
    height: 36px;
    border: 1px solid
        ${({pathname}) => {
            return pathname === '/' ? COLORS.secundaria : COLORS.primaria
        }};
    border-radius: 10px;
    margin-left: 16px;
    color: ${({pathname}) => {
        return pathname === '/' ? COLORS.secundaria : COLORS.primaria
    }};
    cursor: pointer;
`

const Credits = styled.div<{pathname: string}>`
    display: flex;
    flex-direction: column;
    min-width: 63px;
    padding: 5px;
    height: 23px;
    height: 23px;
    border-radius: 10px;
    font-size: 14px;
    background-color: ${({pathname}) => {
        return pathname === '/'
            ? COLORS.secundariaEscura
            : COLORS.primariaEscura
    }};
    color: #ffffff;
    align-items: center;
    justify-content: center;
`

interface Props {
    visibility: string
}

const Alert = styled.div<Props>`
    color: ${(props) => props.visibility};
    transition: color 0.25s;
`

export default function LeftBar() {
    const [show, setShow] = useState(() => {
        if (typeof window !== 'undefined') {
            return window.innerWidth > 1090
        }
        return true
    })
    const {userInfo, logout} = useContext(AuthContext)
    const {createNewChat, limits, alertVisibility, isChat, setIsChat} =
        useContext(HistoryContext)
    const [openList, setOpenList] = useState(false)
    const listRef = useRef<HTMLDivElement | null>(null)
    const [selectedButton, setSelectedButton] = useState<
        'chats' | 'documentos' | null
    >(() => {
        return window.location.pathname === '/projetos' ? 'documentos' : 'chats'
    })
    const navigate = useNavigate()
    const handleChatsClick = () => {
        setSelectedButton('chats')
        setIsChat(true)
        createNewChat()
        navigate('/')
    }
    const handleDocumentosClick = () => {
        setSelectedButton('documentos')
        setIsChat(false)
        navigate('/projetos')
    }
    const createInitialsSVG = (firstName: string, lastName?: string) => {
        const initials =
            (firstName?.[0] || '').toUpperCase() +
            (lastName?.[0] || '').toUpperCase()
        const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="30" height="30">
            <circle cx="20" cy="20" r="20" fill="#012441"/>
            <text x="20" y="25" text-anchor="middle" fill="white" font-size="16" font-family="Arial">${initials}</text>
            </svg>`
        return `data:image/svg+xml;base64,${btoa(svg)}`
    }
    const location = useLocation()
    const [logoSrc, setLogoSrc] = useState(logo)
    const cookieService = useMemo(() => new CookiesService(), [])
    const [authToken, setAuthToken] = useState<string>('')

    useEffect(() => {
        const authData = cookieService.getAuthData()
        if (authData?.access_token) {
            setAuthToken(authData.access_token)
        }
    }, [cookieService])

    const {decodedToken} = useJwt(authToken)

    type DecodedAuthToken = {
        sub: string
        name: string
        id: string
        scopes: string[]
        organization: {
            id: string
            name: string
        }
        modules: string[]
        assistants: string[]
        exp: number
        iat: number
    }

    const modules = useMemo(() => {
        if (!decodedToken) return []
        const typedToken = decodedToken as DecodedAuthToken
        return typedToken.modules ?? []
    }, [decodedToken])

    const featureAccess = useMemo(() => {
        const hasModule = (moduleKeys: string | string[]) => {
            if (!modules || modules.length === 0) return false
            const keys = Array.isArray(moduleKeys) ? moduleKeys : [moduleKeys]

            const normalizedKeys = keys.map((key) => key.toLowerCase())

            return modules.some((module) =>
                normalizedKeys.includes(module.toLowerCase())
            )
        }

        return {
            chats: hasModule(['chat']),
            documents: hasModule(['document_generator']),
            analyzer: hasModule(['document_analyzer']),
            priceResearch: hasModule(['price_research']),
            carona: hasModule(['carona_inteligente']),
            // Radar de Fornecedor vive no serviço de pesquisa de preços e usa o mesmo acesso
            // (o backend não exige claim próprio). Trocar p/ 'radar_fornecedor' se o core passar
            // a emitir um módulo dedicado.
            radar: hasModule(['price_research']),
        }
    }, [modules])

    const {
        chats: canAccessChats,
        documents: canAccessDocuments,
        analyzer: canAccessAnalyzer,
        priceResearch: canAccessPriceResearch,
        carona: canAccessCarona,
        radar: canAccessRadar,
    } = featureAccess

    useEffect(() => {
        if (!authToken || modules.length === 0) return
        console.log('Decoded Token Modules:', modules)
    }, [authToken, modules])

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (
                listRef.current &&
                !listRef.current.contains(event.target as Node)
            ) {
                setOpenList(false)
            }
        }
        if (openList) {
            document.addEventListener('mousedown', handleClickOutside)
        } else {
            document.removeEventListener('mousedown', handleClickOutside)
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [openList])

    const messageCreditsCurrent = limits?.usages?.messages?.current ?? 0
    const messageCreditsMax = limits?.usages?.messages?.max ?? 0
    const projectCreditsCurrent = limits?.usages?.projects?.current ?? 0
    const projectCreditsMax = limits?.usages?.projects?.max ?? 0

    return (
        <>
            <Section show={show}>
                <Wrapper>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '0 14px',

                            width: '100%',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                            }}
                        >
                            <Logo src={IMAGES.logo} alt="Logo Schief.ai" />
                        </div>
                        <img
                            src={menuLateralIcon}
                            alt="Fechar menu"
                            title="Fechar menu"
                            style={{
                                width: '24px',
                                height: '24px',

                                cursor: 'pointer',
                            }}
                            onClick={() => setShow((prev) => !prev)}
                        />
                    </div>

                    {(canAccessChats ||
                        canAccessDocuments ||
                        canAccessAnalyzer ||
                        canAccessPriceResearch ||
                        canAccessCarona ||
                        canAccessRadar) && (
                        <>
                            {canAccessChats && (
                                <Tooltip
                                    title="Criar nova consulta"
                                    placement="right"
                                >
                                    <MuiButton
                                        onClick={handleChatsClick}
                                        startIcon={
                                            <img
                                                src={MessageIcon}
                                                alt="Criar novo chat"
                                                style={{
                                                    width: '20px',
                                                    height: '20px',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    filter: 'none',
                                                }}
                                            />
                                        }
                                        sx={{
                                            alignSelf: 'center',
                                            border: 'none',
                                            borderRadius: '14px',
                                            justifyContent: 'flex-start',
                                            width: '90%',
                                            fontSize: '14px',
                                            fontWeight: 'bold',
                                            textTransform: 'none',
                                            color: COLORS.cinzaEscuro,
                                            backgroundColor:
                                                selectedButton === 'chats' &&
                                                location.pathname === '/'
                                                    ? COLORS.secundaria
                                                    : COLORS.branco,
                                            padding: '13.2px 13px',
                                            gap: '10px',
                                            '& .MuiButton-startIcon': {
                                                marginRight: 0,
                                                marginLeft: 0,
                                            },
                                            '&:hover': {
                                                backgroundColor:
                                                    selectedButton ===
                                                        'chats' &&
                                                    location.pathname === '/'
                                                        ? COLORS.secundaria
                                                        : COLORS.branco,
                                                border: 'none',
                                            },
                                        }}
                                    >
                                        Consultas
                                    </MuiButton>
                                </Tooltip>
                            )}

                            {canAccessDocuments &&
                                !window.location.hostname.includes(
                                    'procon'
                                ) && (
                                    <MuiButton
                                        onClick={handleDocumentosClick}
                                        startIcon={
                                            <img
                                                src={FolderIcon}
                                                alt="Criar Documento"
                                                style={{
                                                    width: '20px',
                                                    height: '20px',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    filter: 'brightness(0)',
                                                }}
                                            />
                                        }
                                        sx={{
                                            alignSelf: 'center',
                                            border: 'none',
                                            borderRadius: '14px',
                                            justifyContent: 'flex-start',
                                            width: '90%',
                                            fontSize: '14px',
                                            fontWeight: 'bold',
                                            textTransform: 'none',
                                            color: COLORS.cinzaEscuro,
                                            backgroundColor:
                                                selectedButton === 'documentos'
                                                    ? COLORS.primaria
                                                    : COLORS.branco,
                                            padding: '13.2px 13px',
                                            gap: '10px',
                                            '& .MuiButton-startIcon': {
                                                marginRight: 0,
                                                marginLeft: 0,
                                            },
                                            '&:hover': {
                                                backgroundColor:
                                                    selectedButton ===
                                                    'documentos'
                                                        ? COLORS.primaria
                                                        : COLORS.branco,
                                                border: 'none',
                                            },
                                        }}
                                    >
                                        Documentos
                                    </MuiButton>
                                )}

                            {canAccessAnalyzer &&
                                !window.location.hostname.includes(
                                    'procon'
                                ) && (
                                    <div
                                        style={{
                                            position: 'relative',
                                            width: '90%',
                                            marginLeft: '12px',
                                        }}
                                    >
                                        <Tooltip
                                            title="Analisar documentos"
                                            placement="right"
                                        >
                                            <MuiButton
                                                onClick={() =>
                                                    navigate('/analisador')
                                                }
                                                startIcon={
                                                    <FindInPageOutlinedIcon
                                                        style={{
                                                            width: '20px',
                                                            height: '20px',
                                                        }}
                                                    />
                                                }
                                                sx={{
                                                    border: 'none',
                                                    borderRadius: '14px',
                                                    justifyContent:
                                                        'flex-start',
                                                    width: '100%',
                                                    fontSize: '14px',
                                                    fontWeight: 'bold',
                                                    textTransform: 'none',
                                                    color: COLORS.cinzaEscuro,
                                                    backgroundColor:
                                                        location.pathname ===
                                                        '/analisador'
                                                            ? COLORS.primaria
                                                            : COLORS.branco,
                                                    padding: '13.2px 13px',
                                                    gap: '10px',
                                                    '& .MuiButton-startIcon': {
                                                        marginRight: 0,
                                                        marginLeft: 0,
                                                    },
                                                    '&:hover': {
                                                        backgroundColor:
                                                            location.pathname ===
                                                            '/analisador'
                                                                ? COLORS.primaria
                                                                : COLORS.branco,
                                                        border: 'none',
                                                    },
                                                }}
                                            >
                                                Análise de Documentos
                                            </MuiButton>
                                        </Tooltip>
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: '4px',
                                                right: '6px',
                                                backgroundColor: '#3ACDB4',
                                                color: '#ffffff',
                                                padding: '2px 10px',
                                                borderRadius: '47px',
                                                fontSize: '9px',
                                                fontWeight: 'bold',
                                                whiteSpace: 'nowrap',
                                            }}
                                        >
                                            Novidade
                                        </div>
                                    </div>
                                )}

                            {canAccessPriceResearch && (
                                <Tooltip
                                    title="Pesquisa de Preços"
                                    placement="right"
                                >
                                    <MuiButton
                                        onClick={() =>
                                            navigate('/pesquisa-precos')
                                        }
                                        startIcon={
                                            <RequestQuoteOutlinedIcon
                                                sx={{
                                                    width: '20px',
                                                    height: '20px',
                                                    color: COLORS.cinzaEscuro,
                                                }}
                                            />
                                        }
                                        sx={{
                                            border: 'none',
                                            borderRadius: '14px',
                                            justifyContent: 'flex-start',
                                            width: '90%',
                                            marginLeft: '12px',
                                            fontSize: '14px',
                                            fontWeight: 'bold',
                                            textTransform: 'none',
                                            color: COLORS.cinzaEscuro,
                                            backgroundColor:
                                                location.pathname ===
                                                '/pesquisa-precos'
                                                    ? COLORS.primaria
                                                    : COLORS.branco,
                                            padding: '13.2px 13px',
                                            gap: '10px',
                                            '& .MuiButton-startIcon': {
                                                marginRight: 0,
                                                marginLeft: 0,
                                            },
                                            '&:hover': {
                                                backgroundColor:
                                                    location.pathname ===
                                                    '/pesquisa-precos'
                                                        ? COLORS.primaria
                                                        : COLORS.branco,
                                                border: 'none',
                                            },
                                        }}
                                    >
                                        Pesquisa de Preços
                                    </MuiButton>
                                </Tooltip>
                            )}

                            {canAccessRadar && (
                                <Tooltip
                                    title="Radar de Fornecedor"
                                    placement="right"
                                >
                                    <MuiButton
                                        onClick={() =>
                                            navigate('/radar-fornecedor')
                                        }
                                        startIcon={
                                            <PersonSearchOutlinedIcon
                                                sx={{
                                                    width: '20px',
                                                    height: '20px',
                                                    color: COLORS.cinzaEscuro,
                                                }}
                                            />
                                        }
                                        sx={{
                                            border: 'none',
                                            borderRadius: '14px',
                                            justifyContent: 'flex-start',
                                            width: '90%',
                                            marginLeft: '12px',
                                            fontSize: '14px',
                                            fontWeight: 'bold',
                                            textTransform: 'none',
                                            color: COLORS.cinzaEscuro,
                                            backgroundColor:
                                                location.pathname ===
                                                '/radar-fornecedor'
                                                    ? COLORS.primaria
                                                    : COLORS.branco,
                                            padding: '13.2px 13px',
                                            gap: '10px',
                                            '& .MuiButton-startIcon': {
                                                marginRight: 0,
                                                marginLeft: 0,
                                            },
                                            '&:hover': {
                                                backgroundColor:
                                                    location.pathname ===
                                                    '/radar-fornecedor'
                                                        ? COLORS.primaria
                                                        : COLORS.branco,
                                                border: 'none',
                                            },
                                        }}
                                    >
                                        Radar de Fornecedor
                                    </MuiButton>
                                </Tooltip>
                            )}

                            {canAccessCarona && (
                                <Tooltip
                                    title="Ata Inteligente"
                                    placement="right"
                                >
                                    <MuiButton
                                        onClick={() => navigate('/carona')}
                                        startIcon={
                                            <HandshakeOutlinedIcon
                                                sx={{
                                                    width: '20px',
                                                    height: '20px',
                                                    color: COLORS.cinzaEscuro,
                                                }}
                                            />
                                        }
                                        sx={{
                                            border: 'none',
                                            borderRadius: '14px',
                                            justifyContent: 'flex-start',
                                            width: '90%',
                                            marginLeft: '12px',
                                            fontSize: '14px',
                                            fontWeight: 'bold',
                                            textTransform: 'none',
                                            color: COLORS.cinzaEscuro,
                                            backgroundColor:
                                                location.pathname === '/carona'
                                                    ? COLORS.primaria
                                                    : COLORS.branco,
                                            padding: '13.2px 13px',
                                            gap: '10px',
                                            '& .MuiButton-startIcon': {
                                                marginRight: 0,
                                                marginLeft: 0,
                                            },
                                            '&:hover': {
                                                backgroundColor:
                                                    location.pathname ===
                                                    '/carona'
                                                        ? COLORS.primaria
                                                        : COLORS.branco,
                                                border: 'none',
                                            },
                                        }}
                                    >
                                        Ata Inteligente
                                    </MuiButton>
                                </Tooltip>
                            )}
                        </>
                    )}
                    {/* {alertVisibility === 'red' && (
                        <Alert visibility={alertVisibility}>
                            Você já está em um novo chat!
                        </Alert>
                    )} */}
                    {isChat && window.location.pathname == '/' ? (
                        <div
                            style={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'flex-start',
                                justifyContent: 'space-between',
                            }}
                        >
                            <History />
                            {window.location.pathname === '/' &&
                                !window.location.hostname.includes(
                                    'procon'
                                ) && (
                                    <AddCommentOutlinedIcon
                                        fontSize="medium"
                                        onClick={() => handleChatsClick()}
                                        titleAccess="Criar nova consulta"
                                        style={{
                                            color: COLORS.secundariaEscura,
                                            cursor: 'pointer',
                                            marginRight: '10px',
                                            marginTop: '5px',
                                        }}
                                    />
                                )}
                        </div>
                    ) : (
                        <List
                            style={{width: '90%', marginBottom: '300px'}}
                        ></List>
                    )}
                </Wrapper>

                <ListWrapper ref={listRef}>
                    {openList && <NavList />}
                    <ButtonsContainer>
                        <CreditsContainer>
                            <CreditsContainerTop>
                                <Credits pathname={window.location.pathname}>
                                    {window.location.pathname === '/'
                                        ? 'CHAT'
                                        : 'DOCUMENTOS'}
                                </Credits>
                                <span
                                    style={{color: '#ABABAB', fontSize: '12px'}}
                                >
                                    {window.location.pathname === '/'
                                        ? `${messageCreditsCurrent}/${messageCreditsMax} `
                                        : `${projectCreditsCurrent}/${projectCreditsMax} `}
                                    Créditos
                                </span>
                            </CreditsContainerTop>
                        </CreditsContainer>
                        <Button
                            onclick={() => setOpenList((prev) => !prev)}
                            IconAltText="Abrir Lista de Configurações"
                            text={`${userInfo.first_name}`}
                            SVGIcon={createInitialsSVG(
                                userInfo.first_name,
                                userInfo.last_name
                            )}
                            align="left"
                            // endText={`${limits.current_answers}/${limits.max_answers}`}
                            tooltip="Conta"
                            customStyle={{
                                border: 'none',
                                padding: '8px 16px',
                                background: 'transparent',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                width: '90%',
                                justifyContent: 'flex-start',
                                paddingLeft: '20px',
                            }}
                        />
                        <Button
                            onclick={logout}
                            IconAltText="sair"
                            text="Sair"
                            SVGIcon={exitIcon}
                            align="left"
                            customStyle={{
                                border: 'none',
                                padding: '8px 16px',
                                background: 'transparent',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                width: '90%',
                                justifyContent: 'flex-start',
                                paddingLeft: '20px',
                            }}
                        />
                    </ButtonsContainer>
                </ListWrapper>
            </Section>
            <HideShowBarButton
                position="left"
                offset={show ? LEFTBAR_WIDTH : '0px'}
                show={show}
                setShow={setShow}
            />
        </>
    )
}
